import "./Home.css";
import Lottie from "react-lottie";
import { useEffect } from "react";
/**
 * Chips Contents - Figma (node-id 4296-4974) 기반 수직 이미지 레이아웃
 * - 수직으로 이미지/섹션을 순서대로 배치
 * - max-width 768px: 768 이하 = 전체 너비, 768 초과 = 768px 고정
 */
const SECTIONS = [
  {
    type: "lottie",
    path: "https://cdn.chips.today/logic/barcode/zips/2026/03/06/1772783643594-bd0b27ea-e5ed-4f60-8ccc-2b944d3a8a13.json",
    alt: "",
  },
  {
    type: "image",
    src: "https://cdn.chips.today/logic/images/2026/03/06/1772783684010-f66d8e77-987c-4895-b842-1ddd42ffb970.png",
    alt: "",
  },
  {
    type: "image",
    src: "https://cdn.chips.today/logic/images/2026/03/06/1772783704706-38d370ce-cf61-4afb-8745-c2f2326f2cd6.png",
    alt: "",
  },
  {
    type: "lottie",
    path: "https://cdn.chips.today/logic/barcode/zips/2026/03/06/1772783726563-e6e1da88-121e-4db1-b572-69d5f41bf786.json",
    alt: "",
  },
  {
    type: "image",
    src: "https://cdn.chips.today/logic/images/2026/03/06/1772786502882-df74eb59-334c-4caf-85c3-543bd5490eca.png",
    alt: "",
  },
];

const STORE_LINK = "https://link.chips.today/sj4w209";
const QUERY_PARAM_HIDE_CHANNEL_TALK = "hide_channeltalk";
const DESCRIPTION_FOR_SEO = "평소처럼 쿠팡 쇼핑하고 칩스로 추가 적립 받아요";

function bootChannelTalk() {
  if (window.ChannelIO) {
    return;
  }

  (function () {
    var w = window;
    if (w.ChannelIO) {
      return w.console.error("ChannelIO script included twice.");
    }
    var ch = function () {
      ch.c(arguments);
    };
    ch.q = [];
    ch.c = function (args) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
      var x = document.getElementsByTagName("script")[0];
      if (x.parentNode) {
        x.parentNode.insertBefore(s, x);
      }
    }
    if (document.readyState === "complete") {
      l();
    } else {
      w.addEventListener("DOMContentLoaded", l);
      w.addEventListener("load", l);
    }
  })();

  window.ChannelIO("boot", {
    pluginKey: "1a1c0fb6-42e5-47ea-93d0-e672ea7999f4",
  });
}

function HomeSection({ section }) {
  if (section.type === "lottie") {
    return (
      <section className="Home__section Home__section--lottie">
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            path: section.path,
            rendererSettings: { preserveAspectRatio: "xMinYMin meet" },
          }}
          isClickToPauseDisabled
        />
      </section>
    );
  }
  return (
    <section className="Home__section">
      <img src={section.src} alt={section.alt} loading="lazy" />
    </section>
  );
}

function Home() {
  useEffect(() => {
    const hideChannelTalkParam = new URLSearchParams(
      window.location.search,
    ).get(QUERY_PARAM_HIDE_CHANNEL_TALK);
    const shouldHideChannelTalk =
      hideChannelTalkParam !== null &&
      hideChannelTalkParam.toLowerCase() !== "false";
    if (!shouldHideChannelTalk) {
      bootChannelTalk();
    }
  }, []);

  return (
    <main className="Home">
      <h1 className="sr-only">{DESCRIPTION_FOR_SEO}</h1>
      <div className="Home__container">
        {SECTIONS.map((section, i) => (
          <HomeSection key={i} section={section} />
        ))}

        <section className="Home__section Home__section--store">
          <a
            href={STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="Home__store-link"
            aria-label="Google Play Store에서 다운로드"
          >
            <img
              src="https://cdn.chips.today/logic/images/2026/03/06/1772783998501-8bb71e36-a512-4ecc-948e-09a78750ec62.png"
              alt="Google Play"
              loading="lazy"
            />
          </a>
          <a
            href={STORE_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="Home__store-link"
            aria-label="App Store에서 다운로드"
          >
            <img
              src="https://cdn.chips.today/logic/images/2026/03/06/1772783975586-d13de46d-40ee-4d3d-880b-5debc2790665.png"
              alt="App Store"
              loading="lazy"
            />
          </a>
        </section>

        <footer className="Home__footer">
          <table>
            <tbody>
              <tr>
                <td>회사명</td>
                <td>주식회사 엔비티</td>
              </tr>
              <tr>
                <td>주소</td>
                <td>서울특별시 강남구 논현로 145길 31, 06041</td>
              </tr>
              <tr>
                <td>전화</td>
                <td>1522-1859</td>
              </tr>
              <tr>
                <td>팩스</td>
                <td>0303-0945-1859</td>
              </tr>
              <tr>
                <td>사업자등록번호</td>
                <td>211-88-83652</td>
              </tr>
              <tr>
                <td>대표자</td>
                <td>박수근</td>
              </tr>
            </tbody>
          </table>
          <div className="Home__copyright">
            Copyright 2022. NBT Inc. All Rights Reserved.
          </div>
        </footer>
      </div>
    </main>
  );
}

export default Home;
